import { ServiceRequest } from "../../api/ServiceRequest";

export class FuelRequest extends ServiceRequest {
  name?: string;
  priceRangeStart?: number;
  priceRangeEnd?: number;

  constructor(init?: Partial<FuelRequest>) {
    super(init); // passes common props
    Object.assign(this, init); // assigns Fuel-specific props
  }

  // Getters & Setters
  getName(): string | undefined {
    return this.name;
  }
  setName(value: string | undefined): void {
    this.name = value;
  }

  getPriceRangeStart(): number | undefined {
    return this.priceRangeStart;
  }
  setPriceRangeStart(value: number | undefined): void {
    this.priceRangeStart = value;
  }

  getPriceRangeEnd(): number | undefined {
    return this.priceRangeEnd;
  }
  setPriceRangeEnd(value: number | undefined): void {
    this.priceRangeEnd = value;
  }
}
